import logging from '@sstdev/lib_logging';
import { BbState } from 'lib_ui-primitives';
import { globalConfig as getGlobalConfig } from 'lib_ui-services';
export const _private = { BbState, getGlobalConfig };
export default {
    verb: 'didUpsert',
    namespace: 'identity',
    relation: 'tenantSetting',
    description: 'Update the tenantSettings used throughout the app when an update comes in over sockets',
    //this is the actual logic:
    logic
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").WorkflowStack} WorkflowStack
 * @typedef {import("rulesengine.io").Context} Context
 *
 * @typedef {import('@sstdev/types').TenantSettings} TenantSettings
 */

/**
 * @param {{
 *   data: {items: TenantSettings[]};
 *   prerequisiteResults: object[];
 *   context: Context;
 *   workflowStack: WorkflowStack[];
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {Promise<void>}
 */
async function logic({ data }) {
    try {
        const record = data.items?.[0];
        if (record == null) {
            return;
        }
        // load all the tenant settings into BBState:
        await _private.BbState.loadTenantSettings(record);
        // Some places need access to RFID and Tenant Settings synchronously
        // e.g. when determining the appropriate RFID tag normalization policy in lib_ui-services/src/rfidStrategy.js
        const globalConfig = _private.getGlobalConfig();
        globalConfig.setRfidConfig(record.rfid || {});
        globalConfig.setTenantSettings(record);
    } catch (err) {
        logging.error(err);
    }
}
